import React, { Component } from "react";
import { connect } from "react-redux";
import { getProductsByCategory } from "../../store/actions/product";
import { setCategory, getCategoryBySlug } from "../../store/actions/category";
import PageTitle from "../../components/shared/PageTitle";
import CategoriesWidget from "../../components/shared/CategoriesWidget";
import CartWidget from "../../components/shared/CartWidget";

import ProductItem from "../../components/ProductItem";
import Loading from "../../components/shared/Loading";

class Category extends Component {
  componentDidMount() {
    if (this.props.location.state) {
      this.props.setCategory(this.props.location.state.category);
    } else {
      this.props.getCategoryBySlug(this.props.match.params.slug);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.state) {
      if (
        prevProps.location.state.category !== this.props.location.state.category
      ) {
        this.props.setCategory(this.props.location.state.category);
      }
    } else {
      if (this.props.location.state) {
        this.props.setCategory(this.props.location.state.category);
      }
    }
  }

  render() {
    return (
      <React.Fragment>
        <PageTitle
          title={
            this.props.category.category && this.props.category.category.title
          }
        />
        <div className="row">
          <div className={"container"}>
            <div className="row">
              <div className={"col-md-9"}>
                <div
                  className={"row"}
                  style={{ marginTop: 20, marginBottom: 50 }}
                >
                  {this.props.product.fetching ? (
                    <Loading />
                  ) : this.props.product.products.length > 0 ? (
                    this.props.product.products.map((product, i) => (
                      <ProductItem {...product} itemSize={"col-md-3"} key={i} />
                    ))
                  ) : (
                    <div>Kayıtlı Ürün Bulunamadı.</div>
                  )}
                </div>
              </div>
              <div className={"col-md-3"} style={{ marginTop: 50 }}>
                <CartWidget />
                <CategoriesWidget />
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ category, product }) => {
  return { category, product };
};

const mapDispatchToProps = {
  getProductsByCategory,
  setCategory,
  getCategoryBySlug,
};

export default connect(mapStateToProps, mapDispatchToProps)(Category);



// WEBPACK FOOTER //
// ./src/routers/Category/index.js